import soundtrack from "../assets/sounds/music/foam_rubber.mp3";
import sneakyAdventure from "../assets/sounds/music/sneaky_adventure.mp3";
import windhowl from "../assets/sounds/music/windhowl.mp3";
import brick from "../assets/sounds/effects/bricksound.mp3";
import concrete from "../assets/sounds/effects/concrete.mp3";
import welcome from "../assets/sounds/effects/welcome.mp3";
import thunder from "../assets/sounds/effects/thunder.mp3";
import rumble from "../assets/sounds/effects/rumbling.mp3";
import woosh from "../assets/sounds/effects/whoosh.mp3";
import activate from "../assets/sounds/effects/activated.mp3";
import stake from "../assets/sounds/effects/staked.mp3";
import claim from "../assets/sounds/effects/tokenclaim.mp3";
import withdraw from "../assets/sounds/effects/tokenwithdraw.mp3";
import fastwhoosh from "../assets/sounds/effects/fastwhoosh.mp3";
import energy from "../assets/sounds/effects/energy.mp3";
import alpenhorn from "../assets/sounds/effects/alpenhorn.mp3";
import pop from "../assets/sounds/effects/pop.mp3";
import longhowl from "../assets/sounds/effects/longhowl.mp3";
import lurkinggrowl from "../assets/sounds/effects/lurkinggrowl.mp3";
import trailinggrowl from "../assets/sounds/effects/trailinggrowl.mp3";
import button from "../assets/sounds/effects/button1.mp3";
import login from "../assets/sounds/effects/login.mp3";
import logoff from "../assets/sounds/effects/logoff.mp3";
import wrong from "../assets/sounds/effects/wrong.mp3";

import metadata from "../assets/docs/metadata_search_query.json";

import logo from "../assets/images/logo.webp";
import baselogo from "../assets/images/baselogo.webp";
import air1 from "../assets/images/air1-image.webp";
import air2 from "../assets/images/air2-image.webp";
import air3 from "../assets/images/air3-image.webp";
import air4 from "../assets/images/air4-image.webp";
import air5 from "../assets/images/air5-image.webp";
import air6 from "../assets/images/air6-image.webp";
import blueHalftone from "../assets/images/blue_halftone.webp";
import greenHalftone from "../assets/images/green_halftone.webp";
import redHalftone from "../assets/images/red_halftone.webp";

/* storyboards */
import Forest from '../assets/images/web/STORYBOARD/Forest.webp';
import Mecha from '../assets/images/web/STORYBOARD/Mecha.webp';
import City from '../assets/images/web/STORYBOARD/City.webp';
import Frost from '../assets/images/web/STORYBOARD/Frost.webp';
import Ruins from '../assets/images/web/STORYBOARD/Ruins.webp';

/* storyboards Mobile */
import ForestMobile from '../assets/images/mobile/STORYBOARD/Forest.webp'
import MechaMobile from '../assets/images/mobile/STORYBOARD/Mecha.webp'
import CityMobile from '../assets/images/mobile/STORYBOARD/City.webp'
import FrostMobile from '../assets/images/mobile/STORYBOARD/Frost.webp'
import RuinsMobile from '../assets/images/mobile/STORYBOARD/Ruins.webp'

/* heroes */
import Androcles from '../assets/images/web/HERO/Androcles.webp';
import Arges from '../assets/images/web/HERO/Arges.webp';
import Damiarchos from '../assets/images/web/HERO/Damiarchos.webp';
import Eurassa from '../assets/images/web/HERO/Eurassa.webp';
import Johantor from '../assets/images/web/HERO/Johantor.webp';
import Kleomenes from '../assets/images/web/HERO/Kleomenes.webp';
import Kratos from '../assets/images/web/HERO/Kratos.webp';
import Luisthenes from '../assets/images/web/HERO/Luisthenes.webp';
import Lysandros from '../assets/images/web/HERO/Lysandros.webp';
import Marista from '../assets/images/web/HERO/Marista.webp';
import Mykalos from '../assets/images/web/HERO/Mykalos.webp';
import Nikandros from '../assets/images/web/HERO/Nikandros.webp';
import Pelagia from '../assets/images/web/HERO/Pelagia.webp';
import Samarchos from '../assets/images/web/HERO/Samarchos.webp';
import Thalina from '../assets/images/web/HERO/Thalina.webp';
import Xerion from '../assets/images/web/HERO/Xerion.webp';
import Xu from '../assets/images/web/HERO/Xu.webp';
import Yohaanikos from '../assets/images/web/HERO/Yohaanikos.webp';

/* heroes Mobile */
import AndroclesMobile from '../assets/images/mobile/HERO/Androcles.webp'
import ArgesMobile from '../assets/images/mobile/HERO/Arges.webp'
import DamiarchosMobile from '../assets/images/mobile/HERO/Damiarchos.webp'
import EurassaMobile from '../assets/images/mobile/HERO/Eurassa.webp'
import JohantorMobile from '../assets/images/mobile/HERO/Johantor.webp'
import KleomenesMobile from '../assets/images/mobile/HERO/Kleomenes.webp'
import KratosMobile from '../assets/images/mobile/HERO/Kratos.webp'
import LuisthenesMobile from '../assets/images/mobile/HERO/Luisthenes.webp'
import LysandrosMobile from '../assets/images/mobile/HERO/Lysandros.webp'
import MaristaMobile from '../assets/images/mobile/HERO/Marista.webp'
import MykalosMobile from '../assets/images/mobile/HERO/Mykalos.webp'
import NikandrosMobile from '../assets/images/mobile/HERO/Nikandros.webp'
import PelagiaMobile from '../assets/images/mobile/HERO/Pelagia.webp'
import SamarchosMobile from '../assets/images/mobile/HERO/Samarchos.webp'
import ThalinaMobile from '../assets/images/mobile/HERO/Thalina.webp'
import XerionMobile from '../assets/images/mobile/HERO/Xerion.webp'
import XuMobile from '../assets/images/mobile/HERO/Xu.webp'
import YohaanikosMobile from '../assets/images/mobile/HERO/Yohaanikos.webp'

/* villains */
import Minotaur from '../assets/images/web/VILLAIN/Minotaur.webp';
import Chimera from '../assets/images/web/VILLAIN/Chimera.webp';
import Hydra from '../assets/images/web/VILLAIN/Hydra.webp';
import Lycaon from '../assets/images/web/VILLAIN/Lycaon.webp';
import Medusa from '../assets/images/web/VILLAIN/Medusa.webp';
import Polyphemus from '../assets/images/web/VILLAIN/Polyphemus.webp';
import Harpies from '../assets/images/web/VILLAIN/Harpies.webp';
import Keres from '../assets/images/web/VILLAIN/Keres.webp';

/* villains Mobile */
import MinotaurMobile from '../assets/images/mobile/VILLAIN/Minotaur.webp'
import ChimeraMobile from '../assets/images/mobile/VILLAIN/Chimera.webp'
import HydraMobile from '../assets/images/mobile/VILLAIN/Hydra.webp'
import LycaonMobile from '../assets/images/mobile/VILLAIN/Lycaon.webp'
import MedusaMobile from '../assets/images/mobile/VILLAIN/Medusa.webp'
import PolyphemusMobile from '../assets/images/mobile/VILLAIN/Polyphemus.webp'
import HarpiesMobile from '../assets/images/mobile/VILLAIN/Harpies.webp'
import KeresMobile from '../assets/images/mobile/VILLAIN/Keres.webp'

/* patrons */
import Zeus from '../assets/images/web/PATRON/Zeus.webp';
import Apollo from '../assets/images/web/PATRON/Apollo.webp';
import Artemis from '../assets/images/web/PATRON/Artemis.webp';
import Athena from '../assets/images/web/PATRON/Athena.webp';
import Demeter from '../assets/images/web/PATRON/Demeter.webp';
import Dionysus from '../assets/images/web/PATRON/Dionysus.webp';
import Hades from '../assets/images/web/PATRON/Hades.webp';
import Hephaestus from '../assets/images/web/PATRON/Hephaestus.webp';
import Hermes from '../assets/images/web/PATRON/Hermes.webp';
import Poseidon from '../assets/images/web/PATRON/Poseidon.webp';

/* patrons Mobile */
import ZeusMobile from '../assets/images/mobile/PATRON/Zeus.webp'
import ApolloMobile from '../assets/images/mobile/PATRON/Apollo.webp'
import ArtemisMobile from '../assets/images/mobile/PATRON/Artemis.webp'
import AthenaMobile from '../assets/images/mobile/PATRON/Athena.webp'
import DemeterMobile from '../assets/images/mobile/PATRON/Demeter.webp'
import DionysusMobile from '../assets/images/mobile/PATRON/Dionysus.webp'
import HadesMobile from '../assets/images/mobile/PATRON/Hades.webp'
import HephaestusMobile from '../assets/images/mobile/PATRON/Hephaestus.webp'
import HermesMobile from '../assets/images/mobile/PATRON/Hermes.webp'
import PoseidonMobile from '../assets/images/mobile/PATRON/Poseidon.webp'

/* artifacts */
import Aegis from '../assets/images/web/ARTIFACT/Aegis.webp';
import Bow from '../assets/images/web/ARTIFACT/Bow.webp';
import Cauldron from '../assets/images/web/ARTIFACT/Cauldron.webp';
import Club from '../assets/images/web/ARTIFACT/Club.webp';
import Girdle from '../assets/images/web/ARTIFACT/Girdle.webp';
import Helm from '../assets/images/web/ARTIFACT/Helm.webp';
import Spear from '../assets/images/web/ARTIFACT/Spear.webp';
import Sword from '../assets/images/web/ARTIFACT/Sword.webp';
import Talaria from '../assets/images/web/ARTIFACT/Talaria.webp';
import Wool from '../assets/images/web/ARTIFACT/Wool.webp';

/* artifacts Mobile */
import AegisMobile from '../assets/images/mobile/ARTIFACT/Aegis.webp'
import BowMobile from '../assets/images/mobile/ARTIFACT/Bow.webp'
import CauldronMobile from '../assets/images/mobile/ARTIFACT/Cauldron.webp'
import ClubMobile from '../assets/images/mobile/ARTIFACT/Club.webp'
import GirdleMobile from '../assets/images/mobile/ARTIFACT/Girdle.webp'
import HelmMobile from '../assets/images/mobile/ARTIFACT/Helm.webp'
import SpearMobile from '../assets/images/mobile/ARTIFACT/Spear.webp'
import SwordMobile from '../assets/images/mobile/ARTIFACT/Sword.webp'
import TalariaMobile from '../assets/images/mobile/ARTIFACT/Talaria.webp'
import WoolMobile from '../assets/images/mobile/ARTIFACT/Wool.webp'

import noHeroFound from "../assets/images/noherofound.webp";

/* legendary heroes */
import Bette from '../assets/images/web/LEGEND/Heroes/Bette.webp';
import Curl from '../assets/images/web/LEGEND/Heroes/Curl.webp';
import Devon from '../assets/images/web/LEGEND/Heroes/Devon.webp';
import Gerald from '../assets/images/web/LEGEND/Heroes/Gerald.webp';
import Kahl from '../assets/images/web/LEGEND/Heroes/Kahl.webp';
import Loki from '../assets/images/web/LEGEND/Heroes/Loki.webp';
import Maine from '../assets/images/web/LEGEND/Heroes/Maine.webp';
import Makki from '../assets/images/web/LEGEND/Heroes/Makki.webp';
import Mau from '../assets/images/web/LEGEND/Heroes/Mau.webp';
import Munch from '../assets/images/web/LEGEND/Heroes/Munch.webp';
import Persia from '../assets/images/web/LEGEND/Heroes/Persia.webp';
import Scot from '../assets/images/web/LEGEND/Heroes/Scot.webp';
import Siam from '../assets/images/web/LEGEND/Heroes/Siam.webp';

/* Legendary Choices (selection tray + center portrait) */
import LongGunGary from '../assets/images/web/LEGEND/Choices/LongGunGary.webp';
import BazooMacho from '../assets/images/web/LEGEND/Choices/BazooMacho.webp';
import BossLugo from '../assets/images/web/LEGEND/Choices/BossLugo.webp';
import CJ from '../assets/images/web/LEGEND/Choices/CJ.webp';
import CornyNorma from '../assets/images/web/LEGEND/Choices/CornyNorma.webp';
import DevilMonty from '../assets/images/web/LEGEND/Choices/DevilMonty.webp';
import FreddyWild from '../assets/images/web/LEGEND/Choices/FreddyWild.webp';
import GROM from '../assets/images/web/LEGEND/Choices/GROM.webp';
import MadameFlo from '../assets/images/web/LEGEND/Choices/MadameFlo.webp';
import ManicMary from '../assets/images/web/LEGEND/Choices/ManicMary.webp';
import McBrad from '../assets/images/web/LEGEND/Choices/McBrad.webp';
import NoNameSally from '../assets/images/web/LEGEND/Choices/NoNameSally.webp';
import OneLineSheila from '../assets/images/web/LEGEND/Choices/OneLineSheila.webp';
import RockyLaw from '../assets/images/web/LEGEND/Choices/RockyLaw.webp';
import SassyLassie from '../assets/images/web/LEGEND/Choices/SassyLassie.webp';
import SoberTaka from '../assets/images/web/LEGEND/Choices/SoberTaka.webp';
import SunnySide from '../assets/images/web/LEGEND/Choices/SunnySide.webp';

/* Legendary Matches (right portrait — only after a play result) */
import MatchLongGunGary from '../assets/images/web/LEGEND/Matches/LongGunGary.webp';
import MatchBazooMacho from '../assets/images/web/LEGEND/Matches/BazooMacho.webp';
import MatchBossLugo from '../assets/images/web/LEGEND/Matches/BossLugo.webp';
import MatchCJ from '../assets/images/web/LEGEND/Matches/CJ.webp';
import MatchCornyNorma from '../assets/images/web/LEGEND/Matches/CornyNorma.webp';
import MatchDevilMonty from '../assets/images/web/LEGEND/Matches/DevilMonty.webp';
import MatchFreddyWild from '../assets/images/web/LEGEND/Matches/FreddyWild.webp';
import MatchGROM from '../assets/images/web/LEGEND/Matches/GROM.webp';
import MatchMadameFlo from '../assets/images/web/LEGEND/Matches/MadameFlo.webp';
import MatchManicMary from '../assets/images/web/LEGEND/Matches/ManicMary.webp';
import MatchMcBrad from '../assets/images/web/LEGEND/Matches/McBrad.webp';
import MatchNoNameSally from '../assets/images/web/LEGEND/Matches/NoNameSally.webp';
import MatchOneLineSheila from '../assets/images/web/LEGEND/Matches/OneLineSheila.webp';
import MatchRockyLaw from '../assets/images/web/LEGEND/Matches/RockyLaw.webp';
import MatchSassyLassie from '../assets/images/web/LEGEND/Matches/SassyLassie.webp';
import MatchSoberTaka from '../assets/images/web/LEGEND/Matches/SoberTaka.webp';
import MatchSunnySide from '../assets/images/web/LEGEND/Matches/SunnySide.webp';
import MatchK9 from '../assets/images/web/LEGEND/Matches/K9.webp';

import sos_audit from '../assets/images/audits/SOS_AUDIT.webp';
import tos_audit from '../assets/images/audits/TOS_AUDIT.webp';
import los_audit from '../assets/images/audits/LOS_AUDIT.webp';

import soniclabs from '../assets/images/partners/soniclabs.webp';
import perqfi from '../assets/images/partners/perqfi.webp';
import paintswap from '../assets/images/partners/paintswap.webp';
import ampedfinance from '../assets/images/partners/ampedfinance.webp';
import vibetrading from '../assets/images/partners/vibetrading.webp';
import brainonsonic from '../assets/images/partners/brainonsonic.webp';
import magicsquare from '../assets/images/partners/magicsquare.webp';
import mothvslamp from '../assets/images/partners/mothvslamp.webp';

const documents = {
  Metadata: metadata,
};

/** Mint air-lane faces: distinct Cashcat breeds (not the old cake icons). */
const visualEffects = {
  logo,
  logobase: baselogo,
  air1: Maine,   // Maine Coon
  air2: Siam,    // Siamese
  air3: Persia,  // Persian
  air4: Scot,    // Scottish Fold
  air5: Mau,     // Egyptian Mau
  air6: Curl,    // American Curl
  // keep cake assets available if needed elsewhere
  cake1: air1,
  cake2: air2,
  cake3: air3,
  cake4: air4,
  cake5: air5,
  cake6: air6,
}

const auditArray = [sos_audit,tos_audit,los_audit]

const partnerArray = [
  perqfi,
  paintswap,
  brainonsonic,
  soniclabs,
  ampedfinance,
  vibetrading,
  magicsquare,
  mothvslamp,
]

const miscImages = {
  noHeroFound,
  blueHalftone: blueHalftone,
  greenHalftone: greenHalftone,
  redHalftone: redHalftone,
};

const backgroundMusic = {
  Soundtrack: soundtrack, 
  SneakyAdventure: sneakyAdventure,
  Windhowl: windhowl,
}

const soundEffects = {
  Brick: brick,
  Concrete: concrete,
  Welcome: welcome,
  Thunder: thunder,
  Rumble: rumble,
  Woosh: woosh,
  Activate: activate,
  Stake: stake,
  Claim: claim,
  Withdraw: withdraw,
  Fastwhoosh: fastwhoosh,
  Energy: energy,
  Alpenhorn: alpenhorn,
  Pop: pop,
  Longhowl: longhowl,
  Lurkinggrowl: lurkinggrowl,
  Trailinggrowl: trailinggrowl,
  Button: button,
  Login: login,
  Logoff: logoff,
  Wrong: wrong,
}

const foregroundStoryboards = {
  Forest,
  Mecha,
  City,
  Frost,
  Ruins
}

const foregroundStoryboardsMobile = {
  Mecha: MechaMobile,
  City: CityMobile,
  Forest: ForestMobile,
  Frost: FrostMobile,
  Ruins: RuinsMobile
}

const foregroundHeroes = {
  Androcles,
  Arges,
  Damiarchos,
  Eurassa,
  Johantor,
  Kleomenes,
  Kratos,
  Luisthenes,
  Lysandros,
  Marista,
  Mykalos,
  Nikandros,
  Pelagia,
  Samarchos,
  Thalina,
  Xerion,
  Xu,
  Yohaanikos
}

const foregroundHeroesMobile = {
  Androcles: AndroclesMobile,
  Arges: ArgesMobile,
  Damiarchos: DamiarchosMobile,
  Eurassa: EurassaMobile,
  Johantor: JohantorMobile,
  Kleomenes: KleomenesMobile,
  Kratos: KratosMobile,
  Luisthenes: LuisthenesMobile,
  Lysandros: LysandrosMobile,
  Marista: MaristaMobile,
  Mykalos: MykalosMobile,
  Nikandros: NikandrosMobile,
  Pelagia: PelagiaMobile,
  Samarchos: SamarchosMobile,
  Thalina: ThalinaMobile,
  Xerion: XerionMobile,
  Xu: XuMobile,
  Yohaanikos: YohaanikosMobile
}

const foregroundVillains = {
  Minotaur,
  Chimera,
  Hydra,
  Lycaon,
  Medusa,
  Polyphemus,
  Harpies,
  Keres
} 

const foregroundVillainsMobile = {
  Minotaur: MinotaurMobile,
  Chimera: ChimeraMobile,
  Hydra: HydraMobile,
  Lycaon: LycaonMobile,
  Medusa: MedusaMobile,
  Polyphemus: PolyphemusMobile,
  Harpies: HarpiesMobile,
  Keres: KeresMobile
}

const foregroundPatrons = {
  Zeus,
  Apollo,
  Artemis,
  Athena,
  Demeter,
  Dionysus,
  Hades,
  Hephaestus,
  Hermes,
  Poseidon
}

const foregroundPatronsMobile = {
  Zeus: ZeusMobile,
  Apollo: ApolloMobile,
  Artemis: ArtemisMobile,
  Athena: AthenaMobile,
  Demeter: DemeterMobile,
  Dionysus: DionysusMobile,
  Hades: HadesMobile,
  Hephaestus: HephaestusMobile,
  Hermes: HermesMobile,
  Poseidon: PoseidonMobile
}

const foregroundArtifacts = {
  Aegis,
  Bow,
  Cauldron,
  Club,
  Girdle,
  Helm,
  Spear,
  Sword,
  Talaria,
  Wool
}

const foregroundArtifactsMobile = {
  Aegis: AegisMobile,
  Bow: BowMobile,
  Cauldron: CauldronMobile,
  Club: ClubMobile,
  Girdle: GirdleMobile,
  Helm: HelmMobile,
  Spear: SpearMobile,
  Sword: SwordMobile,
  Talaria: TalariaMobile,
  Wool: WoolMobile
}

const literaryHeroes = {
  Androcles: {
    name: 'Androcles Kronjenidas I',
    phonetic: '/ˈændrəˌkliːz krɒnˈdʒɛnɪdæs ðə fɜːst/',
    text: 'Our meme representation of Andre Cronje, the DeFi hero and Creator of Sonic, the fastest final blockchain on Godˈs green earth. A true blockchain hero for his courage, bravery, sacrifice. His legacy lives on Sparta on Sonic forever.'
  },
  Arges: {
    name: 'Arges of Kerma',
    phonetic: '/ˈɑːdʒiːz əv ˈkɜːmə/',
    text: 'The lost son of Kerma, a Spartan hero of Kermatic heritage.'
  },
  Damiarchos: {
    name: 'Damiarchos Sesticles',
    phonetic: '/ˌdæmiˈɑːrkɒs ˈsɛstɪkliːz/',
    text: 'Our meme representation of the DeFi hero and genius birthing the Def-AI era and debuting it on Sonic blockchain forever. Decentralized defintiely AI.'
  },
  Eurassa: {
    name: 'Eurassa of Corinthos',
    phonetic: '/juːˈræsə əv kɒˈrɪnθɒs/',
    text: 'A daughter of Sparta, a Spartan heroine of Corinthian heritage.'
  },
  Johantor: {
    name: 'Johantor of Magadha',
    phonetic: '/ˈdʒəʊhæntɔːr əv ˈmæɡədə/',
    text: 'A true son of Magadha, a Spartan ally of ancient Magadhan heritage.'
  },
  Kleomenes: {
    name: 'Kleomenes of Theramion',
    phonetic: '/kliːˈɒməniːz əv θəˈræmiɒn/',
    text: 'A son of Sparta, a Spartan hero of Theramian heritage.'
  },
  Kratos: {
    name: 'Kratos Megalos',
    phonetic: '/ˈkreɪtɒs ˈmɛɡəlɒs/',
    text: 'A son of Sparta, a Spartan hero of ancient Sparta.'
  },
  Luisthenes: {
    name: 'Luisthenes Fausticles',
    phonetic: '/luːˈɪsθəniːz ˈfɔːstɪkliːz/',
    text: 'Our meme representation of Luis Fausto, a avid lover and contributor to Sonic.'
  },
  Lysandros: {
    name: 'Lysandros Phokion',
    phonetic: '/laɪˈsændrɒs ˈfəʊkiɒn/',
    text: 'A son of Sparta, born of the famed Phokion.'
  },
  Marista: {
    name: 'Marista of Kush',
    phonetic: '/məˈrɪstə əv kʊʃ/',
    text: 'Our meme representation of Mari, a lover and supporter of Sonic.'
  },
  Mykalos: {
    name: 'Mykalos Kongidon',
    phonetic: '/ˈmaɪkəlɒs ˈkɒndʒɪdɒn/',
    text: 'Our meme representation of Michael Kong, a contributor and diehard lover of all things Sonic.'
  },
  Nikandros: {
    name: 'Nikandros Damarcides',
    phonetic: '/nɪˈkændrɒs ˌdæməˈsaɪdiːz/',
    text: 'The young blooded pup of Sparta with ambition that rivals the gods.'
  },
  Pelagia: {
    name: 'Pelagia Leonis',
    phonetic: '/pəˈleɪdʒə liˈəʊnɪs/',
    text: 'A daughter from a band of explorers with undying loyalty to Sparta, a true beauty and enigma to behold.'
  },
  Samarchos: {
    name: 'Samarchos Harcothon',
    phonetic: '/sæˈmɑːrkɒs hɑːˈkɒθɒn/',
    text: 'Our meme representation of Sam Harcourt, a avid contributor and promoter of Sonic.'
  },
  Thalina: {
    name: 'Thalina Aegidora',
    phonetic: '/θəˈliːnə iːˈdʒɪdərə/',
    text: 'A daughter of Sparta with a perchant for destruction and chaos. Beware of this one.'
  },
  Xerion: {
    name: 'Xerion Talimachos',
    phonetic: '/ˈzɪəriən tæˈlɪməkɒs/',
    text: 'A resurrected ill-begotten son of Sparta, born from the ancient line of Talimachos thought to burnt to ash.'
  },
  Xu: {
    name: 'Xu Ling of Shang Dynasty',
    phonetic: '/ʃuː lɪŋ əv ʃæŋ ˈdɪnəsti/',
    text: 'A cub of the Shang Dynasty whose blood-thirst and love for the destruction of the enemies of Sparta is unrivalled.'
  },
  Yohaanikos: {
    name: 'Yohaanikos Straton',
    phonetic: '/jəʊˈhɑːnɪkɒs ˈstrætɒn/',
    text: 'Our meme representation of Johaan, an avid contributor and supporter of Sonic.'
  }
};

const literaryPatrons = {
  Zeus: { name: 'Zeus', phonetic: '/zjuːs/', text: 'high-throned and bearer of the thunder, watches the battlefield with eyes like storm. When justice wavers, he strikes with lightning to restore the sacred balance among mortal kin.' },
  Apollo: {name: 'Apollo', phonetic: '/əˈpɒləʊ/', text: 'lord of light and lyre, walks unseen where Spartans clash, lending fire to their aim and foresight to their minds. In moments of valor, his golden bow sings through the hands of chosen kin.' },
  Artemis: {name: 'Artemis', phonetic: '/ˈɑːtəmɪs/', text: 'huntress of the moon and guardian of the wild, guides the arrows of Spartan maidens and stills the hearts of foes. She lendeth swift silence to those who stalk as shadows beneath night’s veil.' },
  Athena: {name: 'Athena', phonetic: '/əˈθiːnə/', text: 'grey-eyed bearer of wisdom and warcraft, whispers counsel in the minds of tactful leaders. When the shield-wall holds and the spear finds its mark, know her hand hath touched the soul.' },
  Demeter: {name: 'Demeter', phonetic: '/ˈdɛmətə/', text: 'mother of grain and green field, blesseth the soil ˈneath Spartan feet when they march for just cause. In times of siege and famine, she guardeth the harvest for those who honor her rites.' },
  Dionysus: {name: 'Dionysus', phonetic: '/ˌdaɪəˈnaɪsəs/', text: 'reveler and breaker of bounds, doth stir frenzy in the hearts of Spartan berserkers. Where wine flows and fear falters, his mirth becomes madness that rends the ranks of foes.' },
  Hades: {name: 'Hades', phonetic: '/ˈheɪdiːz/', text: 'lord of the shadowed realm, seeth all who fall ˈneath Spartan blades and welcomes them in solemn silence. Should one stray from fate’s appointed end, his hounds shall bring them low.' },
  Hephaestus: {name: 'Hephaestus', phonetic: '/hɪˈfɛstəs/', text: 'hammer-lord and craftsman divine, doth bless the forge from whence Spartan arms are wrought. Each blade that cleaves with truth and might, rings with echoes of his sacred fire.' },
  Hermes: {name: 'Hermes', phonetic: '/ˈhɜːmiːz/', text: 'Hermes, fleet-footed herald, walks unseen with Spartan scouts and spies, bearing whispers swifter than arrows. When fate hangs by a thread, his sandals carry mercy—or doom—on silent wind.' },
  Poseidon: {name: 'Poseidon', phonetic: '/pəˈsaɪdən/', text: 'Poseidon, earth-shaker and sovereign of seas, stirreth both wave and wrath to shield Sparta’s shores. When storms rise ˈgainst invaders and tridents gleam in foam, it is he who roars his favor.' },
}

const literaryVillains = {
  Minotaur: {
    name: 'Minotaur',
    phonetic: '/ˈmɪnətɔː/',
    text: 'Born of unholy union, the horned beast roams labyrinthine halls with hunger unending. Its roar echoes as a death-knell to those who lose their path in the dark.'
  },
  Chimera: {
    name: 'Chimera',
    phonetic: '/kɪˈmɪərə/',
    text: 'Three-headed and fire-breathing, it is the spawn of nightmare—lion, goat, and serpent fused in fury. None who faced it lived without grievous scar or madness.'
  },
  Hydra: {
    name: 'Hydra',
    phonetic: '/ˈhaɪdrə/',
    text: 'From each severed head, two more do rise with venomous wrath. To fight it is to drown in a tide of fangs and poison.'
  },
  Lycaon: {
    name: 'Lycaon',
    phonetic: '/laɪˈkeɪɒn/',
    text: 'Cursed by Zeus, the man-beast stalks the wilds with eyes aglow in moonlight, thirsting for human flesh. He bears no mercy, only the hunger of a wolf eternal.'
  },
  Medusa: {
    name: 'Medusa',
    phonetic: '/mɪˈdjuːsə/',
    text: 'With serpent hair and gaze of stone, she turns valiant hearts into statues of regret. Her visage is death’s mirror—look upon her and be lost forever.'
  },
  Polyphemus: {
    name: 'Polyphemus',
    phonetic: '/ˌpɒlɪˈfiːməs/',
    text: 'The one-eyed giant, son of Poseidon, crushes foes with mountainous might. To trespass his cave is to invite doom by boulder and bone.'
  },
  Harpies: {
    name: 'Harpies',
    phonetic: '/ˈhɑːpiːz/',
    text: 'Winged hags of the storm, they shriek through the skies with claws thirsting for flesh. Where they fly, pestilence and madness follow.'
  },
  Keres: {
    name: 'Keres',
    phonetic: '/ˈkɪəriːz/',
    text: 'Dark spirits of violent death, they descend upon the dying with bloodied teeth and chilling laughter. No warrior meets them and rises again.'
  },
};

const literaryArtifacts = {
  Aegis: {
    name: 'Aegis',
    phonetic: '/ˈiːdʒɪs/',
    text: 'The shield of gods, wrought by Hephaestus and borne by Zeus and Athena, doth strike terror with its gorgon glare. Were it to guard a Spartan arm, no dart nor blade could undo its bearer.'
  },
  Bow: {
    name: 'Bow of Apollo',
    phonetic: '/bəʊ əv əˈpɒləʊ/',
    text: 'Strung with golden sinew, this bow striketh down from afar with sun-fired wrath. To wield it is to let fly death wrapped in light, as only Apollo might grant.'
  },
  Cauldron: {
    name: 'Cauldron of Medea',
    phonetic: '/ˈkɔːldrən əv mɪˈdiːə/',
    text: 'Within this vile vessel, life is torn and reborn ‘neath sorcery and flame. Were a Spartan to claim it, wounds may close or enemies unmake—yet at peril of soul.'
  },
  Club: {
    name: 'Club of Hercules',
    phonetic: '/klʌb əv ˈhɜːkjʊliːz/',
    text: 'Rough-hewn of olive wood and wrath, this club broke beast and tyrant alike. In a Spartan’s grasp, ‘tis a storm upon shieldwalls and monsters.'
  },
  Girdle: {
    name: 'Girdle of Hippolyta',
    phonetic: '/ˈɡɜːdəl əv hɪˈpɒlɪtə/',
    text: 'This war-belt of the Amazon queen doth pulse with might and command. Let a Spartan maiden wear it, and kings themselves would bow in awe.'
  },
  Talaria: {
    name: 'Talaria',
    phonetic: '/təˈlɛəriə/',
    text: 'Wingèd sandals of Hermes, they fly swifter than thought and lighter than shadow. In Spartan cause, they would carry messages or vengeance across sky and sea.'
  },
  Helm: {
    name: 'Helm of SneakyAdventure',
    phonetic: '/hɛlm əv ˈdɑːknəs/',
    text: 'Wrought by the unseen hand for Hades himself, it cloaks the bearer in silence and fear. For Spartan spy or lone avenger, ‘tis a veil no eye can pierce.'
  },
  Sword: {
    name: 'Sword of Perseus',
    phonetic: '/sɔːd əv ˈpɜːsjuːs/',
    text: 'Forged by divine will, it cleft the head of dread Medusa. Were it borne by a Spartan, no evil born of earth or shadow could endure its arc.'
  },
  Spear: {
    name: 'The Myrmidon Spear',
    phonetic: '/ðə ˈmɜːmɪdɒn spɪə/',
    text: 'Passed down from Achilles’ line, this spear doth thirst for glory. In Spartan phalanx, ‘twould sing a song of ruin unmatched by mortal war.'
  },
  Wool: {
    name: 'Wool of Chrysomallos',
    phonetic: '/wʊl əv krɪsəˈmælɒs/',
    text: 'Golden fleece of a ram divine, its threads weave luck, healing, and protection. Spartans would die to drape it ‘bout their wounded or their war-banner.'
  },
};

const literaryData = {
  heroes: literaryHeroes,
  villains: literaryVillains,
  patrons: literaryPatrons,
  artifacts: literaryArtifacts
};

const LegendaryHeroes = {
  Bette,
  Curl,
  Devon,
  Gerald,
  Kahl,
  Loki,
  Maine,
  Makki,
  Mau,
  Munch,
  Persia,
  Scot,
  Siam
}

const LegendaryChoices = {
  BazooMacho,
  BossLugo,
  CJ,
  CornyNorma,
  DevilMonty,
  FreddyWild,
  GROM,
  MadameFlo,
  ManicMary,
  McBrad,
  NoNameSally,
  LongGunGary,
  OneLineSheila,
  RockyLaw,
  SassyLassie,
  SoberTaka,
  SunnySide
}

/** Match-art counterparts (right stage). Keys align with LegendaryChoices where possible. */
const LegendaryMatches = {
  BazooMacho: MatchBazooMacho,
  BossLugo: MatchBossLugo,
  CJ: MatchCJ,
  CornyNorma: MatchCornyNorma,
  DevilMonty: MatchDevilMonty,
  FreddyWild: MatchFreddyWild,
  GROM: MatchGROM,
  MadameFlo: MatchMadameFlo,
  ManicMary: MatchManicMary,
  McBrad: MatchMcBrad,
  NoNameSally: MatchNoNameSally,
  LongGunGary: MatchLongGunGary,
  OneLineSheila: MatchOneLineSheila,
  RockyLaw: MatchRockyLaw,
  SassyLassie: MatchSassyLassie,
  SoberTaka: MatchSoberTaka,
  SunnySide: MatchSunnySide,
  K9: MatchK9,
}

export { backgroundMusic, soundEffects, visualEffects, documents, 
  foregroundStoryboards, foregroundHeroes, foregroundVillains, literaryData, miscImages,
  foregroundPatrons, foregroundArtifacts, foregroundStoryboardsMobile, foregroundHeroesMobile, 
  foregroundVillainsMobile, foregroundPatronsMobile, foregroundArtifactsMobile,
  LegendaryHeroes, LegendaryChoices, LegendaryMatches, auditArray, partnerArray };